import { render } from "./trueOrFalse.vue?vue&type=template&id=24b6c0d4&scoped=true"
import script from "./trueOrFalse.vue?vue&type=script&lang=js"
export * from "./trueOrFalse.vue?vue&type=script&lang=js"

import "./trueOrFalse.vue?vue&type=style&index=0&id=24b6c0d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b6c0d4"]])

export default __exports__